import { ref } from 'vue'
import { useDeviceEventLogStore } from './store/deviceEventLog'
import { useFacilityPhotoStore } from './data/Editor/facilityPhoto'
import { useDefectPhotoStore } from './data/Editor/defectPhoto'
import { useShapeStore } from './data/Editor/shape'

export enum UploadDatabase {
  TaskAsset = 'taskAsset',
  FacilityBranchImage = 'facilityBranchImage',
  Shape = 'shape',
  DefectPhoto = 'defectPhoto',
}

export enum UploadStatus {
  Waiting = 'waiting',
  Progressing = 'progressing',
  Success = 'success',
  Error = 'error',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AppUpload {
  export const uploadStatusMap = ref(
    new Map<
      string,
      {
        database: UploadDatabase
        key: string
        status: UploadStatus
        localStringIds: string[]
      }
    >(),
  )

  export const status = ref<
    {
      key: string
      progress: number
      length: number
    }[]
  >([])

  export async function uploadAll(): Promise<void> {
    const facilityPhotoStore = useFacilityPhotoStore()
    const shapeStore = useShapeStore()
    const defectPhotoStore = useDefectPhotoStore()
    const deviceEventLogStore = useDeviceEventLogStore()

    facilityPhotoStore.uploadNotUploaded()
    shapeStore.uploadNotUploaded()
    defectPhotoStore.uploadNotUploaded()
    deviceEventLogStore.uploadNotUploaded()
  }
}
